<div class="flex">
  <div class="flex-1 margin-left-small margin-right-small">
    <h4 class="margin-bottom">Company Name</h4>
    <div class="card">
      <div><b>Vat Number</b></div>
      123123213213
      <div class="margin-top-small"><b>Social Security Number</b></div>
      123123213213
      <div class="margin-top-small"><b>Company Category</b></div>
      Corporate
      <div class="margin-top-small"><b>Comment</b></div>
      Lorem ipsum, dolor sit amet consectetur adipisicing elit.
      <div class="margin-top align-right">
        <button><i class="fa fa-pencil"></i>Edit</button>
      </div>
    </div>
  </div>
  <div class="flex-1 margin-left-small margin-right-small">
    <h4 class="margin-bottom">Address info</h4>
    <div class="card">
      <h4>Adress Titolo</h4>
      descrizione
      <hr class="margin-top margin-bottom">

      <div class="grid-3">

        <div>
          <div><b>Address Part</b></div>
          Largo
        </div>


        <div>
          <div><b>Street</b></div>
          Maurizio vitale
        </div>

        <div>
          <div><b>Number</b></div>
          1
        </div>

        <div>
          <div><b>Town</b></div>
          Torino
        </div>

        <div>
          <div><b>Procince</b></div>
          TO
        </div>

        <div>
          <div><b>ZIP Code</b></div>
          10100
        </div>

        <div>
          <div><b>PA Code</b></div>
          123123213123
        </div>

        <div>
          <div><b>SDI Code</b></div>
          435345435
        </div>
      </div>

      <hr class="margin-top margin-bottom">

      <div class="grid-3">
        <div class="span">
          <div><b>Email</b></div>
          {{'quesrt@gmail.com'}}
        </div>
        <div>
          <div><b>Contact Type</b></div>
          email
        </div>
      </div>

      <hr class="margin-top margin-bottom">

      <div class="grid-3">

        <div>
          <div><b>Int Code</b></div>
          +39
        </div>


        <div>
          <div><b>Phone number</b></div>
          123123213
        </div>

        <div>
          <div><b>Contact Type</b></div>
          Assistant Phone
        </div>
      </div>






      <div class="align-right margin-top">
        <button><i class="fa fa-pencil"></i> Edit</button>
      </div>

    </div>




  </div>
  <div class="flex-1 margin-left-small margin-right-small">
    <h4 class="margin-bottom">Account Info</h4>
    <div class="card">
      <h4>Name</h4>
      Role
      <div class="margin-top">
        <input class="margin-bottom full-width"
               placeholder="Name"
               type="text">
      </div>
      <div>
        <input class="margin-bottom  full-width"
               placeholder="Mail"
               type="text">
      </div>
      <div>
        <input class="margin-bottom full-width"
               placeholder="password"
               type="text">
      </div>

      <div class="margin-bottom">
        <div class="margin-bottom-small">
          <input type="checkbox"> <label> Admin</label>
        </div>
        <div class="margin-bottom-small">
          <input type="checkbox"> <label> Contributor</label>
        </div>
        <div class="margin-bottom-small">
          <input type="checkbox"> <label> User</label>
        </div>
      </div>

      <div class="align-right">
        <button class="warning margin-right"><i class="fa fa-trash"></i> Delete</button>
        <button><i class="fa fa-pencil"></i> Edit</button>
      </div>


    </div>
  </div>
